<template>
  <div class="mx-auto rounded p-6 bg-white border col-span-2 sm:col-span-1 md:col-span-2 w-full">
    <div
      class="flex items-center w-full"
      v-if="company && company.logo_url"
    >
      <img
        class="h-6 w-auto"
        @error="company.logo = false"
        style="object-fit: scale-down; min-height: 100%"
        :src="company.logo_url"
        :alt="company.logo"
      />
    </div>
    <span
      v-else-if="company"
      class="flex items-center h-6 text-gray-900 hover:text-primary-600"
      >{{ company.name }}</span
    >
    <span
      v-else
      class="flex items-center"
    >
      <img
        class="h-5 w-auto logo"
        src="/images/black_logo.png"
        alt=""
      />
    </span>
    <table class="w-full mt-4">
      <tbody>
        <tr>
          <td class="text-left text-gray-800 pb-2">Invoice</td>
          <td class="text-right text-gray-800 pb-2">#{{ invoice?.number }}</td>
        </tr>
        <tr>
          <td class="text-left text-gray-800 pb-2">Due date</td>
          <td class="text-right text-gray-800 pb-2">{{ formatDate(invoice?.due_date) }}</td>
        </tr>
        <tr>
          <td class="text-left text-gray-800 pb-2">Invoice amount</td>
          <td class="text-right pb-2 text-gray-800">
            {{ formatAmount(invoice.amount_due, invoice.currency) }}
          </td>
        </tr>
        <tr v-if="showPriorPayments">
          <td class="text-left text-gray-800 pb-2">Prior payments</td>
          <td class="text-right pb-2 text-gray-800">-{{ priorPaymentsTotal }}</td>
        </tr>
        <tr v-if="intent && intent.credit_memo_amount_applied && intent.credit_memo_amount_applied < 0">
          <td class="text-left text-gray-800 pb-2">Credit applied</td>
          <td class="text-right pb-2 text-gray-800">
            {{ formatAmount(intent.credit_memo_amount_applied, invoice.currency) }}
          </td>
        </tr>
        <tr>
          <td class="text-left text-gray-800 pb-2">Amount due</td>
          <td class="text-right pb-2 text-gray-800 font-bold">{{ amountToPay }}</td>
        </tr>
      </tbody>
    </table>
    <div class="mt-3 flex justify-between flex-wrap gap-2">
      <div>
        <a
          :href="invoice.preview_url"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center focus:ring-4 border font-medium rounded-lg text-xs px-5 py-2 focus:outline-none text-gray-500 border-gray-300 hover:bg-gray-100 focus:ring-primary-300"
        >
          View invoice
        </a>
      </div>
      <div class="flex flex-row gap-2">
        <a
          :href="invoice.preview_url"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center focus:ring-4 border font-medium rounded-lg text-xs px-3 py-2 focus:outline-none text-gray-500 border-gray-300 hover:bg-gray-100 focus:ring-primary-300"
        >
          <ion-icon
            name="print-outline"
            class="w-4 h-4"
          />
        </a>
        <a
          :href="invoice.download_url"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center focus:ring-4 border font-medium rounded-lg text-xs px-3 py-2 focus:outline-none text-gray-500 border-gray-300 hover:bg-gray-100 focus:ring-primary-300"
        >
          <ion-icon
            name="download-outline"
            class="w-4 h-4"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import DateUtils from "../../../js/helpers/DateUtils"
import currencyUtils from "../../../js/helpers/currencyUtils"
import currency from "currency.js"

export default {
  name: "PortalInvoiceDetailCard",

  props: {
    invoice: { type: Object, default: () => ({}) },
    intent: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      company: window.FinancialCents.company || null,
    }
  },

  computed: {
    amountToPay() {
      return this.formatAmount(this.invoice.outstanding_amount, this.invoice.currency)
    },

    showPriorPayments() {
      // Show prior payments whenever payments have been made, regardless of allow_partial_payments flag
      // This is because firm users can now make partial payments on any invoice
      return this.invoice.amount_due - this.invoice.credits > this.invoice.outstanding_amount
    },

    priorPaymentsTotal() {
      const invoiceTotal = currencyUtils.convertFromCents(
        this.invoice.amount_due - this.invoice.credits,
        this.invoice.currency,
      )
      const priorPayments = currencyUtils.convertFromCents(this.invoice.outstanding_amount, this.invoice.currency)

      return currencyUtils.formatCurrency(currency(invoiceTotal).subtract(priorPayments).value, this.invoice.currency)
    },
  },

  methods: {
    formatDate(date) {
      return DateUtils.formatDate(date, "MMM Do, YYYY", false, true)
    },

    formatAmount(amount, currency) {
      return currencyUtils.convertAndFormatCurrency(amount, currency, navigator.language)
    },
  },
}
</script>
